import { render, staticRenderFns } from "./Credit.vue?vue&type=template&id=02a73ddb&scoped=true"
import script from "./Credit.vue?vue&type=script&lang=ts"
export * from "./Credit.vue?vue&type=script&lang=ts"
import style0 from "./Credit.vue?vue&type=style&index=0&id=02a73ddb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../DATA/projects/nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a73ddb",
  null
  
)

export default component.exports